

























































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import ModalConfirm from '@/shared/modals/modal-confirm.component.vue';
import User from '@/domain/user/user.entity';
import ProjectPersist from '@/domain/project/project-persist.entity';
import { ProjectMember } from '@/domain/project/project-with-members.entity';
import TextField from '@/shared/text-field/text-field.component.vue';
import UserService from '@/domain/user/user.service';
import ButtonComponent from '@/shared/button/button.component.vue';
import ProjectFormRules from '@/views/project/project-form.rules';
import BusinessUnit from '@/domain/businessUnit/businessUnit.entity';
import BusinessUnitService from '@/domain/businessUnit/businessUnit.service';
import CostCenter from '@/domain/costCenter/costCenter.entity';
import AuthorityStore from '@/domain/security/authority.store';
import Role from '@/domain/role/role.entity';
import RoleService from '@/domain/role/role.service';
import Seniority from '@/domain/seniority/seniority.entity';
import SeniorityService from '@/domain/seniority/seniority.service';

@Component({
  components: {
    ModalConfirm,
    TextField,
    ButtonComponent,
  },
})
export default class ProjectForm extends Vue {
  @Prop({
    required: true,
    default: new ProjectPersist(),
  })
  private project!: ProjectPersist;

  @Prop({
    required: true,
    default: false,
  })
  private editingProject!: boolean;

  private get headerTitle() {
    return this.editingProject === true ? this.$t('editProject') : this.$t('newProject');
  }

  private newProject: ProjectPersist = new ProjectPersist();

  private activeUsers: User[] = [];

  private roles: Role[] = [];

  private seniorities: Seniority[] = [];

  private businessUnits: BusinessUnit[] = [];

  private businessUnit: BusinessUnit = BusinessUnit.of({});

  private costCenters: CostCenter[] = [];

  private costCenter: CostCenter = CostCenter.of({});

  private userToAdd: User | null = null;

  private roleIdToAdd: string | null = null;

  private seniorityIdToAdd: string | null = null;

  private dialogModal: boolean = false;

  private formRules: ProjectFormRules = new ProjectFormRules();

  public $refs!: any;

  isAdministrator: boolean = false;

  private openConfirmModal(): void {
    this.dialogModal = true;
  }

  private closeConfirmModal(): void {
    this.dialogModal = false;
  }

  private get validateForm(): boolean {
    return this.$refs.form.validate();
  }

  private get validateProjectObjectChanges(): boolean {
    return JSON.stringify(this.project) === JSON.stringify(this.newProject);
  }

  private save(): void {
    if (this.validateForm) {
      this.$emit('saveProject', this.newProject);
    }
  }

  private close(): void {
    if (!(this.validateProjectObjectChanges)) {
      this.openConfirmModal();
    } else {
      this.closeAllModalsAndResetFieldsAndValidation();
    }
  }

  private cancel(): void {
    this.closeConfirmModal();
  }

  private resetFieldsAndValidation(): void {
    this.$refs.form.reset();
  }

  private closeAllModalsAndResetFieldsAndValidation(): void {
    this.$emit('close');
    this.closeConfirmModal();
    this.resetFieldsAndValidation();
  }

  private getUserList(): Promise<void> {
    return UserService.searchAllActiveUsers()
      .then(users => users.forEach((user: User) => this.activeUsers.push(user)));
  }

  private getRoleList(): Promise<void> {
    return RoleService.searchAllActiveRoles()
      .then((roles: Role[]) => { this.roles = roles; });
  }

  private getSeniorityList(): Promise<void> {
    return SeniorityService.searchAllSeniorities()
      .then((seniorities: Seniority[]) => { this.seniorities = seniorities; });
  }

  private get availableUsers(): User[] {
    return this.activeUsers.filter(user => !this.newProject.projectUsers
      .some(projectUser => projectUser.username === user.username));
  }

  private get sortedProjectUsers(): User[] {
    return [...this.newProject.projectUsers]
      .sort((a, b) => a.username.localeCompare(b.username));
  }

  private getMember(user: User): ProjectMember {
    return this.newProject.members.find(candidate => candidate.user.username === user.username)
      || new ProjectMember({ user });
  }

  private onUserToAddChange(user: User | null): void {
    this.userToAdd = user;
    this.roleIdToAdd = user && user.roleId ? user.roleId : null;
    this.seniorityIdToAdd = user && user.seniorityId ? user.seniorityId : null;
  }

  private addMember(): void {
    if (!this.userToAdd) return;

    const user = this.userToAdd;
    const role = this.roles.find(candidate => candidate.id === this.roleIdToAdd);
    const seniority = this.seniorities.find(candidate => candidate.id === this.seniorityIdToAdd);

    this.newProject.projectUsers = [...this.newProject.projectUsers, user];
    this.newProject.members = [...this.newProject.members, new ProjectMember({
      user,
      roleId: role ? role.id : undefined,
      roleName: role ? role.name : undefined,
      seniorityId: seniority ? seniority.id : undefined,
      seniorityName: seniority ? seniority.name : undefined,
    })];

    this.userToAdd = null;
    this.roleIdToAdd = null;
    this.seniorityIdToAdd = null;
  }

  private removeMember(user: User): void {
    this.newProject.projectUsers = this.newProject.projectUsers
      .filter(candidate => candidate.username !== user.username);
    this.newProject.members = this.newProject.members
      .filter(member => member.user.username !== user.username);
  }

  private editMember(user: User): void {
    const member = this.getMember(user);
    this.removeMember(user);
    this.userToAdd = this.activeUsers
      .find(candidate => candidate.username === user.username) || user;
    this.roleIdToAdd = member.roleId || null;
    this.seniorityIdToAdd = member.seniorityId || null;
  }

  private getBusinessUnitList(): Promise<void> {
    return BusinessUnitService.searchAllBusinessUnit()
      .then(businessUnits => businessUnits
        .forEach((businnesUnit: BusinessUnit) => {
          this.businessUnits.push(businnesUnit);
          if (businnesUnit.id === this.project.businessUnitId) {
            this.businessUnit = businnesUnit;
            this.getCostCenterList();
          }
        }));
  }

  private getCostCenterList(): void {
    this.costCenters = [];
    if (this.newProject.businessUnitId !== undefined && this.newProject.businessUnitId !== '') {
      BusinessUnitService.searchAllCostCenterByBusinessUnit(this.newProject.businessUnitId)
        .then(costCenters => costCenters
          .forEach((costCenter: CostCenter) => {
            this.costCenters.push(costCenter);
            if (costCenter.id === this.project.costCenterId) this.costCenter = costCenter;
          }));
    }
  }

  private get disableSave(): boolean {
    return this.isNullOrEmpty(this.newProject.name)
    || this.newProject.projectUsers.length < 1;
  }

  private isNullOrEmpty(field: any): boolean {
    return field == null || field === '';
  }

  mounted() {
    this.getUserList();
    this.getRoleList();
    this.getSeniorityList();
    this.getBusinessUnitList();
    this.newProject = ProjectPersist.of(this.project);
    AuthorityStore.isAdministrator().then((isAdministrator: boolean) => {
      this.isAdministrator = isAdministrator;
    });
  }
}
